import {
  Box,
  List,
  ListItemButton,
  Collapse,
  ListItemIcon,
  ListItemText,
  useTheme, Toolbar,
  Typography,
  Button,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { MocImage } from "../../core/widgets/TwoSplitLayout";
import { dashboardStyles } from "../../resources/styles/pages/DashboardStyles";
import { styles } from "../../resources/styles/Styles";
import { VSStyledMenu } from "../../core/widgets/VSStyledMenu";
import Colors from "../../resources/Colors";
import { fontSizes } from "../../resources/Dimens";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { useDispatch, useSelector } from "react-redux";
import userAction from "../../core/store/actions/userAction";
import { MocUserRole } from "../../core/services/models/Enums";
import "./Dashboard.scss";
import {
  Menu,
  frontDeskMenus,
  rmoMenus,
  consultantMenus,
  nurseMenus,
  adminMenus,
  patientMenus,
  mrdMenus,
  homeCareMenus,
  qualityMenus,
  insuranceMenus,
  accountantMenus,
  ceoMenus,
  operationsMenus,
} from "./menus";
import {
  getCurrentLoggedInUser,
  getRoles,
} from "../../core/services/api/userService";
import {
  getAllCenters,
  getCenterDetail,
  getManageStaffDetailsById,
  registerNotificationsToken,
  getPushNotifications, getPatientDetail
} from "../../core/services/api";
import SearchBar from "./Searchbar";
import { messaging } from "../../firebaseNotifications/firebase";
import moment from "moment";
import { getToken } from "firebase/messaging";
import Btn from "../../components/Button/Button";
import Select from "react-select";
import Toast from "components/Toast";
import toastAction from "core/store/actions/toastAction";
import RoutesNavigation from "./routes";
import { useIdleTimer } from "react-idle-timer";
import { CognitoOTPAuthContext } from "cognito/CognitoOTPAuthContext";
import EmptyRightDrawer from "components/EmptyRightDrawer/EmptyRightDrawer";
import { isOpenRoute } from "core/utils/route";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp, faLocationDot, faPhoneVolume, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/free-regular-svg-icons";


const drawerWidth = 80
type AppBarProps = {
  open?: boolean
} & MuiAppBarProps

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}))

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    overflowY: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}))

const DashBoardPanel = ({ envHeaderEnabled = false }: { envHeaderEnabled: boolean }) => {
  const [openNotify, setOpenNotify] = useState(true)
  const [toggleArrow, setToggleArrow] = useState(false)
  const [menus, setMenus] = useState(frontDeskMenus)
  const [isnotify, setIsNotify] = useState<any>()
  const [notification, setnotification] = useState<any>(false)
  const [showRightPane, toggleRightPane] = useState(false)
  const [selectedNavItem, updatedNavItem] = useState<any>()
  const [pageCount, setPageCount] = useState(0) // Initialize page count to 1
  const [role, setRole] = useState<any>()
  const [staffDetails, setStaffDetails] = React.useState<any>()
  const [switchRole, setSwitchRole] = useState<any>(false)
  const [allCenters, setAllCenters] = useState<any>([])
  const [fcmToken, setFcmToken] = useState<any>("")
  const [centerOptions, setcenterOptions] = useState<any>([])
  const [selectedCenter, setSelectedCenter] = useState<any>("")
  const [show, setShow] = useState<boolean>(false)
  const [notificationComplete, setNotificationComplete] = useState<boolean>(false);
  const [isLocationMenuOpen, setIsLocationMenuOpen] = useState<boolean>(false);

  const theme = useTheme()
  const history = useHistory()
  const classes = dashboardStyles(theme)
  const globalStyles = styles(theme)
  const location = useLocation()
  const dispatch = useDispatch()
  const popupRef = useRef<HTMLDivElement>(null)
  const notificationRef = useRef<HTMLDivElement>(null);

  const component = useSelector((state: any) => state.drawer?.componentData)
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const centerDetail = useSelector((state: any) => state?.user?.centerDetail)
  const displayToastDashboard: any = useSelector((state: any) => state?.toast)

  const { isAuthenticated, logout } = useContext(CognitoOTPAuthContext);

  // To log the user out if there is no activity for 1 hour 
  const timeout = 60 * 60 * 1000
  const onIdle = () => {
    logout(false)
  }
  useIdleTimer({
    onIdle,
    timeout,
    throttle: 500
  })

  const centerDropDownRef = useRef(null);

  // get center details from local storage.
  function getCenterDetails() {
    return new Promise((resolve, reject) => {
      try {
        let centerDetail = localStorage.getItem("centerDetail")
        resolve(centerDetail)
      } catch (error) {
        reject(error)
      }
    })
  }

  const toggleMenu = (menu: Menu) => {
    menus.forEach((i: any) => {
      if (i.title === menu.title) {
        i.open = !i.open
      } else {
        i.open = false
      }
    })
    setMenus(menus.concat([]))
  }

  const handleClickOutside = (event: any) => {
    if (popupRef.current && !popupRef.current?.contains(event?.target)) {
      setRole("")
      setSelectedCenter("")
      setSwitchRole(false)
    }
  }

  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))

  const handleClick = (i: Menu) => {
    if (i.route) history.push(i.route)
  }

  const getAllCenterDetails = () => {
    getAllCenters()
      .then((res: any) => {
        setAllCenters(res)
      })
      .catch((err: any) => console.error(err?.message))
  }

  function fetchUserDetail() {
    const role: any = sessionStorage.getItem("currentRole")
    const center: any = sessionStorage.getItem("currentCenter")
    const userDetails: any = sessionStorage.getItem("userDetails")
    const currentCenterDetails: any = sessionStorage.getItem(
      "currentCenterDetails"
    )
    let parsedDetails: any = {}
    if (userDetails) {
      parsedDetails = JSON.parse(userDetails)
    }
    if (!parsedDetails?.id) {
      getCurrentLoggedInUser()
        .then(async (res) => {
          //Set current user data into session storage
          sessionStorage.setItem("currentRole", res?.currentRole)
          sessionStorage.setItem(
            "currentCenter",
            res?.currentCenter ? res?.currentCenter?.centerId : null
          )
          sessionStorage.setItem("currentUserId", res?.id)
          sessionStorage.setItem("userDetails", JSON.stringify(res))
          sessionStorage.setItem(
            "currentCenterDetails",
            JSON.stringify(res?.currentCenter)
          )

          dispatch(userAction.setUserRole(res?.currentRole))
          dispatch(userAction.setUser(res))

          if (res?.currentRole === MocUserRole.OPERATIONS) {
            dispatch(userAction.setReadOnly(true))
          }

          let centerDetail: any = null

          getCenterDetails()
            .then((res) => {
              centerDetail = res
            })
            .catch((err) => {
              console.error(
                "error in fetching center details from local storage",
                err
              )
            })

          centerDetail = centerDetail ? JSON.parse(centerDetail) : {}
          if (res?.currentRole !== MocUserRole.SYSTEM_ADMIN) {
            if (
              centerDetail &&
              centerDetail?.centerId &&
              centerDetail?.centerId === res?.currentCenter?.id
            ) {
              centerDetail["printConfiguration"] = {
                marginTop: "200",
                marginBottom: "5",
                marginLeft: "5",
                marginRight: "5",
              }
              dispatch(userAction.setCenterDetail(centerDetail))
              localStorage.setItem("centerDetail", JSON.stringify(centerDetail))
            } else {
              fetchCenter(res?.currentCenter?.centerId)
            }
          }
        })
        .catch((err) => {
          console.error("err", err)
        })
    } else {
      getCurrentLoggedInUser()
        .then((res: any) => {
          dispatch(userAction.setUserRole(role))
          const temp = { ...parsedDetails }
          temp["currentRole"] = role
          temp["roles"] = res?.roles
          temp["centers"] = res?.centers?.length ? res?.centers : []
          if (currentCenterDetails && currentCenterDetails !== "null") {
            let centerObj: any
            centerObj = JSON.parse(currentCenterDetails)
            if (centerObj) {
              temp["currentCenter"] = centerObj
            }
          } else {
            temp["currentCenter"] = null
          }
          sessionStorage.setItem("userDetails", JSON.stringify(temp))
          dispatch(userAction.setUser(temp))
          if (role === MocUserRole.OPERATIONS) {
            dispatch(userAction.setReadOnly(true))
          }
          let centerDetail: any = null

          getCenterDetails()
            .then((res) => {
              centerDetail = res
            })
            .catch((err) => {
              console.error(
                "error in fetching center details from local storage",
                err
              )
            })

          centerDetail = centerDetail ? JSON.parse(centerDetail) : {}
          if (role !== MocUserRole?.SYSTEM_ADMIN) {
            if (
              centerDetail &&
              centerDetail?.centerId &&
              centerDetail?.centerId === center
            ) {
              centerDetail["printConfiguration"] = {
                marginTop: "200",
                marginBottom: "5",
                marginLeft: "5",
                marginRight: "5",
              }
              dispatch(userAction.setCenterDetail(centerDetail))
              localStorage.setItem("centerDetail", JSON.stringify(centerDetail))
            } else {
              if (center && center !== "null") {
                fetchCenter(center)
              }
            }
          }
        })
        .catch((err) => {
          console.error("err", err)
        })
    }
  }

  function requestPermission(userData: any) {
    setTimeout(async () => {
      const permission = await Notification.requestPermission()
      if (permission === "granted") {
        // generate token
        const notificationToken = await getToken(messaging, {
          vapidKey:
            "BH0GpaWqF5UafGt77y-eJe6Z-Lo506aQAPyTfz7s0R9gSdcpMdBfci4b8mTOjygB79j4viLTzjj-_AtGeuhA0-g",
        })
        setFcmToken(notificationToken)

        //Register token
        if (notificationToken) {
          const payload: any = {
            token: notificationToken,
          }
          if (userData?.roles?.includes("PATIENT")) {
            payload["patientId"] = userData.id
            payload["userType"] = "PATIENT"
          } else {
            payload["staffId"] = userData.id
            payload["userType"] = "staff"
          }

          registerNotificationsToken(payload)
            .then((res: any) => {
              console.log("Token registered successfully", payload)
            })
            .catch((err: any) => console.error(err?.message))
        }
      }
    }, 5000)
  }

  //Working handleScroll
  const handleScroll = (event: any) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget
    if (Math.abs(scrollHeight - scrollTop - clientHeight) <= 1 && !notificationComplete) {
      // Reached the bottom of the scroll
      setPageCount((prevPageCount) => prevPageCount + 1)
      getPushNotifications(userDetail?.id, pageCount + 1).then((res: any) => {
        if (res.length > 0) {
          setIsNotify((prevNotifications: any) => [
            ...prevNotifications,
            ...res,
          ])
          setPageCount(pageCount + 1);
        } else {
          setNotificationComplete(true)
          setIsNotify((prevNotifications: any) => [...prevNotifications])
        }
      })
    }
  }

  const handleNotification = () => {
    if (!notification)
      getPushNotifications(userDetail?.id, 0).then((res: any) => {
        setNotificationComplete(false)
        setPageCount(0)
        setIsNotify(res)
        setnotification(!notification)
      })
  }

  function fetchCenter(centerId: string) {
    getCenterDetail(centerId)
      .then((res: any) => {
        res["printConfiguration"] = {
          marginTop: "200",
          marginBottom: "5",
          marginLeft: "5",
          marginRight: "5",
        }
        dispatch(userAction.setCenterDetail(res?.length > 0 ? res[0] : res))
        localStorage.setItem("centerDetail", JSON.stringify(res))
      })
      .catch((err) => {
        console.error("Failed to fetch center detail", err)
      })
  }

  // Notification Redirection
  const handleNotificationClick = (notificationObj: any) => {
    setnotification(false)
    setShow(false)
    if (
      Object.keys(notificationObj?.data)?.includes("appointmentId") &&
      Object.keys(notificationObj?.data)?.includes("patientId")
    ) {
      const { appointmentId, patientId } = notificationObj?.data
      history?.push(
        `/patientDiagnosis/${patientId}?appointmentId=${appointmentId}`
      )
    } else if (Object.keys(notificationObj?.data)?.includes("invoiceId")) {
      const { invoiceId } = notificationObj?.data
      const { discountApprovalId } = notificationObj?.data
      if (userRole !== MocUserRole?.FRONT_DESK) {
        history?.push(
          `/discountApprovalRequest/${discountApprovalId}/${invoiceId}`
        )
      }
    } else if (
      Object.keys(notificationObj?.data)?.includes("rmoApprovalId") &&
      Object.keys(notificationObj?.data)?.includes("patientId") &&
      Object.keys(notificationObj?.data)?.includes("recordId")
    ) {
      const { rmoApprovalId, patientId, recordId } = notificationObj?.data
      history.push({
        pathname: "/consultantApprovalRequest",
        state: {
          idValue: rmoApprovalId,
          patientIdValue: patientId,
          recordIdValue: recordId,
        },
      })
    } else if (Object.keys(notificationObj?.data)?.includes("patientId")) {
      if (
        notificationObj?.title ===
        "Patient Registration Confirmation to Front desk"
      ) {
        history?.push(`/patientList`)
      } else {
        const { patientId } = notificationObj?.data
        history?.push(`/invoices/${patientId}`)
      }
    } else if (notificationObj?.title === "Chemo Order Approval") {
      if (Object.keys(notificationObj?.data)?.includes("chemoOrderId")) {
        const { chemoOrderId } = notificationObj?.data
        history.push({
          pathname: "/chemoApprovalRequest",
          state: {
            id: chemoOrderId,
          },
        })
      }
    } else {
      history?.push(notificationObj?.data?.webType)
    }
  }

  const getRoleOptions = () => {
    let result = []
    let rolesList: any = [...userDetail?.roles]?.length
      ? [...userDetail?.roles]?.map((role: any) => ({
        value: role,
        label: role,
      }))
      : []
    if (
      userRole === "SYSTEM_ADMIN" ||
      userRole === "MRD" ||
      userRole === "MARKETING" ||
      userRole === "QUALITY" ||
      userRole === "INSURANCE" ||
      userRole === "ACCOUNTANT" ||
      userRole === "OPERATIONS" ||
      userRole === "MANAGEMENT"
    ) {
      result = rolesList?.filter((o: any) => o?.value !== userRole)
    } else {
      result = rolesList
    }
    return result
  }

  const getCenterOptions = () => {
    let result = []
    if (
      staffDetails?.primaryRole === "SYSTEM_ADMIN" ||
      staffDetails?.primaryRole === "MRD" ||
      staffDetails?.primaryRole === "MARKETING" ||
      staffDetails?.primaryRole === "QUALITY" ||
      staffDetails?.primaryRole === "INSURANCE" ||
      staffDetails?.primaryRole === "ACCOUNTANT" ||
      staffDetails?.primaryRole === "OPERATIONS" ||
      staffDetails?.primaryRole === "MANAGEMENT"
    ) {
      result = allCenters?.map((each: any) => {
        return { label: each?.centerName, value: each?.id }
      })
    } else {
      result = userDetail?.centers?.length
        ? userDetail?.centers.map((c: any) => {
          return {
            value: c?.centerId,
            label: c?.centerName,
          }
        })
        : []
    }
    setcenterOptions(result)
  }

  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => {
          userAction.setNotifications([])
          setOpenNotify(false)
        }
        }
      >
        <CloseIcon
          fontSize="small"
        />
      </IconButton>
    </>
  )

  function Sidebar() {
    return (
      <div className="side-bar">
        {location.pathname?.includes("/selfAssesment") ? (
          <Drawer
            variant="permanent"
            open={true}
            className={"side_menu-wrapper"}
          ></Drawer>
        ) : (
          <Drawer
            variant="permanent"
            open={true}
            className={"side_menu-wrapper"}
          >
            <List className="list-menu-wrapper">
              {menus &&
                menus.map((i: any) => (
                  <LightTooltip title={i.title}>
                    <div key={i.title}>
                      <ListItemButton
                        onClick={() => {
                          if (i.children && i.children.length > 0) toggleMenu(i)
                          else {
                            updatedNavItem(i?.title)
                            handleClick(i)
                          }
                        }}
                        className={`${selectedNavItem === i.title ? "bg-primary" : ""}`}
                      >
                        {selectedNavItem === i.title ? i.inactiveIcon : i.activeIcon}
                      </ListItemButton>

                      {i.children && (
                        <Collapse in={i.open} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding>
                            {i.children.length > 0 &&
                              i.children.map((j: any) => (
                                <ListItemButton
                                  onClick={() => {
                                    handleClick(j)
                                  }}
                                >
                                  <ListItemIcon>{j.icon}</ListItemIcon>
                                  <ListItemText primary={j.title} />
                                </ListItemButton>
                              ))}
                          </List>
                        </Collapse>
                      )}
                    </div>
                  </LightTooltip>
                ))}
            </List>
          </Drawer>
        )}
      </div>
    )
  }

  function onSwitchRole(newRole: string | null, newCenter: string) {
    getRoles(newRole, newCenter).then((res) => {
      //Update role
      if (newRole) {
        sessionStorage.setItem("currentRole", newRole)
      }
      //Update Center
      if (newCenter) {
        sessionStorage.setItem("currentCenter", newCenter)
        const centerObj = allCenters?.find((c: any) => c?.id === newCenter)
        if (centerObj) {
          const tempobj = {
            centerId: centerObj?.id,
            centerName: centerObj?.centerName,
            mocCenterId: centerObj?.mocCenterId,
            brandName: centerObj?.brandName,
            companyName: centerObj?.companyName
          }
          sessionStorage.setItem(
            "currentCenterDetails",
            JSON.stringify(tempobj)
          )
        }
      } else {
        sessionStorage.setItem("currentCenter", JSON.stringify(null))
        sessionStorage.setItem("currentCenterDetails", JSON.stringify(null))
      }
      window.location.reload()
      window.location.href = "/"
    })
  }

  function renderProfileMenu() {
    return (
      <VSStyledMenu
        handleClick={handleClick}
        setSwitchRole={setSwitchRole}
        options={renderMenus()}
        fcmToken={fcmToken}
        staffData={staffDetails}
        getAllCenterDetails={getAllCenterDetails}
      />
    )
  }

  function renderMenus() {
    let roleUI = []
    let queryParameters = new URLSearchParams(window?.location?.search)
    let medicalRecordId: any = queryParameters?.get("medicalRecordId")

    {
      !medicalRecordId &&
        roleUI.push(
          <Box className={`${globalStyles.flex}`}>
            {
              <Typography
                fontSize={`${fontSizes.medium} !important`}
                fontWeight="600"
                lineHeight="24px"
              >
                <img
                  style={{
                    width: "20px",
                    height: "15px",
                    paddingRight: "5px",
                  }}
                  alt="switch-role-icon"
                  src="../../assets/images/ProfileIcon.png"
                />
                Switch Role
              </Typography>
            }
          </Box>
        )
    }
    roleUI.push(
      <Box className={`${globalStyles.flex}`}>
        {medicalRecordId ? (
          <Typography
            fontSize={`${fontSizes.medium} !important`}
            fontWeight="600"
            lineHeight="24px"
            display={"none"}
          >
            <img
              style={{
                width: "20px",
                height: "15px",
                paddingRight: "5px",
              }}
              alt="profile-icon"
              src="../../assets/images/ProfileIcon.png"
            />
            Profile
          </Typography>
        ) : (
          <Typography
            fontSize={`${fontSizes.medium} !important`}
            fontWeight="600"
            lineHeight="24px"
          >
            <img
              style={{
                width: "20px",
                height: "15px",
                paddingRight: "5px",
              }}
              alt="profile-icon"
              src="../../assets/images/ProfileIcon.png"
            />
            Profile
          </Typography>
        )}
      </Box>
    )

    roleUI.push(
      <Box className={`${globalStyles.flex}`}>
        <Typography
          fontSize={`${fontSizes.medium} !important`}
          fontWeight="600"
          lineHeight="24px"
          color={Colors.red1}
        >
          <img
            style={{
              width: "20px",
              height: "15px",
              paddingRight: "5px",
            }}
            alt="logout-icon"
            src="../../assets/images/logout-icon.svg"
          />
          Logout
        </Typography>
      </Box>
    )
    return roleUI
  }

  function renderAppHeader() {
    // Add a click event listener to the document
    document.addEventListener("click", function (event: any) {
      if (event.target.closest("#background-notification")) {
      } else {
        // Clicked outside the target div
        setnotification(false)
      }
    })

    const queryParameters = new URLSearchParams(window?.location?.search)
    const medicalRecordId: any = queryParameters?.get("medicalRecordId")

    return (
      <>
        {/* For sticky navbar */}
        {/* <AppBar
          position="sticky"
          sx={{
            background: "white",
            zIndex: 1000,
            top: envHeaderEnabled ? "35px" : "0px"
          }}
          className={classes.headersection}
        > */}

        {/* For scrollable navbar */}
        <AppBar
          position="relative"
          sx={{
            background: "white",
            zIndex: 1000,
            top: envHeaderEnabled ? "0px" : "0px"
          }}
          className={classes.headersection}
        >
          <Toolbar>
            <div
              className={`${classes.headerFlexSection} col-lg-12 col-md-12 p-0`}
            >
              <div
                className="col-md-2 col-lg-1 responsive_margin"
                id="ipad_responsive"
              >
                <MocImage
                  onClick={() => history.push("/")}
                  className={classes.logoImage}
                  src={"/assets/images/logo_moc.png"}
                />
              </div>

              <div className={`${classes.headerFlexSection}`}>
                {userRole !== MocUserRole.PATIENT ? (
                  <div className="responsive_search">
                    <SearchBar componentParent={"Dashboard"} placeholder="Search Patient" />
                  </div>
                ) : null}

                {userRole === MocUserRole.FRONT_DESK ? (
                  <>
                    <Box className={classes.holder}>
                      <Button
                        className={`${classes.addpatientbutton}`}
                        variant="contained"
                        sx={{ borderRadius: "4px" }}
                        onClick={() => {
                          history.push("/addPatient")
                        }}
                      >
                        <FontAwesomeIcon icon={faPlus} size="xl" />
                        <Typography
                          className={classes.buttonTitle}
                          variant="subtitle2"
                        >
                          Add Patient
                        </Typography>
                      </Button>
                    </Box>
                  </>
                ) : null}

                {medicalRecordId ? (
                  ""
                ) : (
                  <>
                    <IconButton
                      color="inherit"
                      onClick={() => history.push("/contactUs")}
                    >
                      <FontAwesomeIcon icon={faPhoneVolume} color="#6B7280" />
                    </IconButton>
                  </>
                )}

                {medicalRecordId ? (
                  ""
                ) : (
                  <>
                    <IconButton
                      aria-label="show 4 new notifications"
                      color="inherit"
                      onClick={handleNotification}
                    >
                      <FontAwesomeIcon icon={faBell} color="#6B7280" />
                      {Array.isArray(isnotify) && isnotify.length > 0 && (
                        <div className="roundeds">
                          <span>
                            {isnotify.length > 50 ? "50+" : isnotify.length}
                          </span>
                        </div>
                      )}
                    </IconButton>
                  </>
                )}

                {userRole !== MocUserRole.PATIENT &&
                  userRole !== MocUserRole.SYSTEM_ADMIN &&
                  userRole !== MocUserRole.ACCOUNTANT &&
                  userRole !== MocUserRole.MRD &&
                  userRole !== MocUserRole.INSURANCE &&
                  userRole !== MocUserRole.QUALITY &&
                  userRole !== MocUserRole.MARKETING &&
                  userRole !== MocUserRole.OPERATIONS &&
                  userRole !== MocUserRole.MANAGEMENT &&
                  userRole !== MocUserRole.HOME_CARE_RMO ? (
                  <Box className={`${globalStyles.flex} align-items-center`}>
                    <FontAwesomeIcon icon={faLocationDot} color="#6B7280" size={"xl"} />
                    <div className="d-flex align-items-center position-relative">
                      <Select
                        ref={centerDropDownRef}
                        options={centerOptions}
                        onMenuOpen={() => {
                          setIsLocationMenuOpen(true)
                        }}
                        onMenuClose={() => {
                          setIsLocationMenuOpen(false)
                        }}
                        onChange={(option: any) => {
                          if (userDetail?.currentCenter?.centerId !== option.value) {
                            setSelectedCenter(option?.value)
                            const currentRole = sessionStorage.getItem("currentRole")
                            setRole(currentRole)
                            onSwitchRole(currentRole, option?.value)
                          }
                        }}
                        placeholder={userDetail?.currentCenter?.centerName}
                        className={classes.centerButtonTitle}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingRight: "20px",
                            border: state.isFocused ? 'gray' : 'none',
                          }),
                          placeholder: (baseStyles, state) => ({
                            ...baseStyles,
                            color: "#1F2937"
                          })
                        }}
                      />
                      <div className="position-absolute end-0 pe-none">
                        <FontAwesomeIcon icon={isLocationMenuOpen ? faCaretUp : faCaretDown} color="#6B7280" size="lg" />
                      </div>
                    </div>
                  </Box>
                ) : null}

                {renderProfileMenu()}
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div className="container" id="notificationId">
          {notification && (
            <>
              <div
                ref={notificationRef}
                className="background-notification"
                id="background-notification"
                style={{
                  height: isnotify?.length > 0 ? "450px" : "70px",
                  width: isnotify?.length > 0 ? "30%" : "20%",
                }}
              >
                {isnotify?.length > 0 ? (
                  isnotify.map((notify: any) => (
                    <div
                      className="notification-item"
                      onClick={() => handleNotificationClick(notify)}
                    >
                      <div className="items">
                        <div>
                          <div className="title_messge">{notify?.title}</div>
                        </div>
                        <span className="contenter">
                          {notify?.notificationMessage}
                        </span>
                        <span className="timefornotification">
                          {moment(
                            notify?.dateTimeOfPushNotificationSent
                          ).format("DD-MM-YYYY,hh:mm A")}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <p style={{ textAlign: "center", paddingTop: "20px" }}>
                    {" "}
                    No notifications available
                  </p>
                )}
              </div>
            </>
          )}
        </div>
        {switchRole && (
          <div className="custom-toast">
            <div id="toastId" className="toast-wrapper">
              <div className={`toast-card card_switch_role`} ref={popupRef}>
                <div className="patient-card-heading">
                  <div className="switch-center-heading">
                    Switch Role/Center
                  </div>
                  <div className="flex textarea m-2">
                    <div className="text-switch-center">Role *</div>
                    <Select
                      ref={switchRoleRef}
                      options={getRoleOptions()}
                      onChange={(option: any) => {
                        getCenterOptions()
                        setRole(option?.value)
                      }}
                      placeholder="Select Role"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #ccd0e7",
                          borderRadius: "10px",
                        }),
                      }}
                    />
                  </div>
                  <div className="flex textarea m-2">
                    {role === "SYSTEM_ADMIN" ||
                      role === "MRD" ||
                      role === "MARKETING" ||
                      role === "QUALITY" ||
                      role === "ACCOUNTANT" ||
                      role === "INSURANCE" ||
                      role === "MANAGEMENT" ||
                      role === "OPERATIONS" ? (
                      ""
                    ) : (
                      <>
                        <div className="text-switch-center">Center *</div>
                        <Select
                          options={centerOptions}
                          onChange={(option: any) => {
                            setSelectedCenter(option?.value)
                          }}
                          placeholder="Select Center"
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              border: "1px solid #ccd0e7",
                              borderRadius: "10px",
                            }),
                          }}
                        />
                      </>
                    )}
                  </div>
                  <div className="button-section">
                    <div className="close-button">
                      <Btn
                        text={"Cancel"}
                        outline={true}
                        onClick={() => {
                          setRole("")
                          setSelectedCenter("")
                          setSwitchRole(false)
                        }}
                        id="onclose-button"
                      />
                    </div>
                    <div className="redirect-button">
                      <Btn
                        text={"Continue"}
                        onClick={() => onSwitchRole(role, selectedCenter)}
                        id="onclick-text"
                        disabled={
                          role === "SYSTEM_ADMIN" ||
                            role === "MRD" ||
                            role === "MARKETING" ||
                            role === "QUALITY" ||
                            role === "ACCOUNTANT" ||
                            role === "INSURANCE" ||
                            role === "MANAGEMENT" ||
                            role === "OPERATIONS"
                            ? false
                            : selectedCenter
                              ? false
                              : true
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  useEffect(() => {
    const accessToken: any = sessionStorage.getItem("accessToken")
    if (!accessToken && !isOpenRoute(history.location.pathname)) history.replace("login")
    if (isAuthenticated) {
      fetchUserDetail()
    }
  }, [isAuthenticated])

  const switchRoleRef = useRef<any>(null);

  useEffect(() => {
    if (switchRole && switchRoleRef.current) {
      switchRoleRef.current.focus();
    }
  }, [switchRole]);

  useEffect(() => {
    if (userDetail) {
      requestPermission(userDetail)
      getAllCenterDetails()
      setOpenNotify(true)
    }
  }, [userDetail])

  useEffect(() => {
    if (userDetail) {
      getCenterOptions()
    }
  }, [userDetail, allCenters])

  useEffect(() => {
    const sidebar = document.querySelector(".side-bar")
    if (sidebar) {
      sidebar.classList.add("frozen")
    }
  }, [])

  useEffect(() => {
    const ele: any = document.getElementById("patient-detail-popover")
    if (ele) {
      if (show) {
        if (ele) {
          ele.style.display = "none"
        }
      } else {
        if (ele) {
          ele.style.display = "block"
          ele.style.position = "absolute"
          ele.style.marginTop = "-370px"
          ele.style.marginLeft = "40px"
          ele.style.overflowY = "scroll"
        }
      }
    }
  }, [show])

  useEffect(() => {
    if (userDetail?.id) {
      getPushNotifications(userDetail?.id, pageCount).then((res: any) => {
        setIsNotify(res)
      })
    }
  }, [userDetail?.id])

  useEffect(() => {
    const scrollContainer = notificationRef?.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll)
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll)
      }
    }
  }, [userDetail?.id, pageCount, handleScroll, notificationComplete])

  useEffect(() => {
    if (location.pathname?.includes("/login")) {
      toggleRightPane(false)
      return
    }
    toggleRightPane(false)
  }, [location.pathname, userRole])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  useEffect(() => {
    if (userDetail?.id) {
      if (userRole !== MocUserRole?.PATIENT) {
        getManageStaffDetailsById(userDetail?.id)
          .then((res: any) => {
            setStaffDetails(res)
            sessionStorage.setItem("profilePicUrl", res?.consultantProfilePic)
          })
          .catch((err: any) => {
            console.error(err?.message)
          })
      } else {
        getPatientDetail(userDetail?.id)
          .then((res: any) => {
            sessionStorage.setItem("profilePicUrl", res?.profileUrl)
          })
          .catch((err: any) => {
            console.error(err?.message)
          })
      }
    }
  }, [userDetail])

  useEffect(() => {
    if (userRole) {
      switch (userRole) {
        case MocUserRole.FRONT_DESK:
          setMenus(frontDeskMenus)
          updatedNavItem("calendar")
          return
        case MocUserRole.RMO:
          setMenus(rmoMenus)
          updatedNavItem("calendar")
          return
        case MocUserRole.CONSULTANT:
        case MocUserRole.NUTRITIONIST:
        case MocUserRole.PHYSIOTHERAPIST:
        case MocUserRole.GENETIC_COUNSELLOR:
        case MocUserRole.PSYCHOLOGIST:
          setMenus(consultantMenus)
          updatedNavItem("calendar")
          return
        case MocUserRole.HOME_CARE_RMO:
          // case MocUserRole.HOME_CARE_NURSE: //CHECK FOR THIS ROLE
          setMenus(homeCareMenus)
          updatedNavItem("calendar")
          return
        case MocUserRole.NURSE:
          setMenus(nurseMenus)
          updatedNavItem("calendar")
          return
        case MocUserRole.CENTER_ADMIN:
        case MocUserRole.SYSTEM_ADMIN:
          setMenus(adminMenus)
          updatedNavItem("home")
          return
        case MocUserRole.OPERATIONS:
          setMenus(operationsMenus)
          updatedNavItem("home")
          return
        case MocUserRole.PATIENT:
          setMenus(patientMenus)
          updatedNavItem("patientDetail")
          return
        case MocUserRole.MRD:
          setMenus(mrdMenus)
          updatedNavItem("ipdList")
          return
        case MocUserRole.QUALITY:
          setMenus(qualityMenus)
          updatedNavItem("qualityIndicator")
          return
        case MocUserRole.INSURANCE:
          setMenus(insuranceMenus)
          updatedNavItem("invoices")
          return
        case MocUserRole.ACCOUNTANT:
          setMenus(accountantMenus)
          updatedNavItem("reports")
          return
        case MocUserRole.CEO:
          setMenus(ceoMenus)
          updatedNavItem("reports")
          return
        case MocUserRole.MARKETING:
          setMenus(ceoMenus)
          updatedNavItem("reports")
          return
        case MocUserRole.MANAGEMENT:
          setMenus(ceoMenus)
          updatedNavItem("reports")
          return
        case MocUserRole.BILL_DESK:
          setMenus(ceoMenus)
          updatedNavItem("reports")
          return
      }
    }
  }, [userRole])

  useEffect(() => {
    const storedTabNumber: any = sessionStorage.getItem("tabID") || null
    if (!storedTabNumber) {
      const min = 100000
      const max = 999999
      const tabNumber = Math.floor(Math.random() * (max - min + 1)) + min
      sessionStorage.setItem("tabID", String(tabNumber))
    }
  }, [])

  useEffect(() => {
    caches.keys().then((names) => {
      names?.forEach((name) => {
        caches.delete(name)
      })
    })
  }, [])

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <>
      {isAuthenticated && <>
        {displayToastDashboard?.toastMessage && (
          <Toast
            textMessage={displayToastDashboard?.toastMessage?.text}
            type={displayToastDashboard?.toastMessage?.type}
            onClose={() => {
              dispatch(toastAction.updateToastFalse())
            }}
            onCloseText="Close"
            onClickText={null}
          />
        )}

        {/* Navbar starts here */}
        {location.pathname?.includes("/login")
          ? null
          : renderAppHeader()}
        {/* Navbar ends here */}

        {/* For scrollable navbar */}
        {/* drawer starts */}
        {location.pathname?.includes("/login")
          ? null
          : Sidebar()}
        {/* drawer ends here */}

        <Box
          sx={{ display: "flex", position: "relative" }}
          onClick={() => (toggleArrow ? setToggleArrow(false) : "")}
        >

          {/* For sticky navbar */}
          {/* drawer starts */}
          {/* {location.pathname?.includes("/login")
            ? null
            : Sidebar()} */}
          {/* drawer ends here */}

          {!(
            location.pathname?.includes("/login")
          ) &&
            !showRightPane &&
            component ? (
            <div
              className={classes.rightPaneMenuSection}
              onClick={() => toggleRightPane(!showRightPane)}
            >
              <img
                className={classes.menuIcon}
                alt="menu-icon"
                src="../../assets/images/rightPaneMenuIcon.svg"
              />
            </div>
          ) : null}
        </Box>
      </>
      }

      <div className="col-md-12 col-lg-12 row">
        <div
          className={`${showRightPane && component ? "col-md-9" : "col-md-12"
            }`}
        >
          <RoutesNavigation
            marginLeft={
              isOpenRoute(location.pathname) && !isAuthenticated ? "0px" : "85px"
            }
          />
        </div>
        {userDetail &&
          userDetail?.id &&
          (userRole === "SYSTEM_ADMIN" ||
            userRole === "MRD" ||
            userRole === "MARKETING" ||
            userRole === "QUALITY" ||
            userRole === "ACCOUNTANT" ||
            userRole === "INSURANCE" ||
            userRole === "MANAGEMENT" ||
            userRole === "OPERATIONS"
            ? true
            : centerDetail?.id) ? (
          <>
            {showRightPane && component ? (
              <div className="col-md-3 col-lg-3 p-0">
                <EmptyRightDrawer onClose={() => toggleRightPane(false)} />
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </>
  )
}

export default DashBoardPanel
